module.exports = __webpack_public_path__ + "img/register.8b1f9a80.svg";